import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { Steps } from 'intro.js-react';
// import style from './Coachmarks.scss';
import { dismissCoachmark } from '../../actions/coachmarks';
import {customisedIntlFormatMessage} from '../../utils/helpers';

const localMessages = defineMessages({
  coachmarkStep: {
    id: 'coachmark.Step',
    defaultMessage: `Coachmark {currentStep} of {numberOfSteps}`,
    description: 'String used to describe current coachmark step',
  },
});

const TOOLTIP_TITLE_FALLBACK_ATTR = 'data-coachmark-fallback-title';
const VISUALLY_HIDDEN_STYLE = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: '0',
};

class Coachmarks extends Component {
  static propTypes = {
    steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    context: PropTypes.string.isRequired,
    initialStep: PropTypes.number,
    dismissCoachmark: PropTypes.func.isRequired,
    intl: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    initialStep: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      enabled: !props[`${props.context}_coachmarks_complete`],
    };
  }

  componentWillUnmount() {
    window.clearTimeout(this.titleFallbackTimer);
  }

  // Fills `.introjs-tooltip-title` with a visually-hidden step label only
  // when Intro.js left it empty; a genuine step title is left untouched.
  applyTooltipTitleFallback = currentStep => {
    const $title = document.querySelector('.introjs-tooltip-title');
    if (!$title) {
      return;
    }

    if ($title.textContent.trim() !== '') {
      if ($title.hasAttribute(TOOLTIP_TITLE_FALLBACK_ATTR)) {
        Object.keys(VISUALLY_HIDDEN_STYLE).forEach(property => $title.style.removeProperty(property));
        $title.removeAttribute(TOOLTIP_TITLE_FALLBACK_ATTR);
      }
      return;
    }

    const { steps, intl } = this.props;
    Object.assign($title.style, VISUALLY_HIDDEN_STYLE);
    $title.setAttribute(TOOLTIP_TITLE_FALLBACK_ATTR, '');
    $title.textContent = customisedIntlFormatMessage(intl, localMessages.coachmarkStep, {
      currentStep,
      numberOfSteps: steps.length,
    });
  };

  handleComplete = () => {
    const { context } = this.props;

    this.setState({
      ...this.state,
      enabled: false,
    });

    this.props.dismissCoachmark({ context });
  };

  handleExit = () => {};

  handleOnChange = nextStepIndex => {
    const { steps, intl, context } = this.props;
    const $tooltip = document.querySelector('.introjs-tooltip');
    const $tooltipText = document.querySelector('.introjs-tooltiptext');
    const currentStep = nextStepIndex + 1;
    $tooltip.setAttribute(
      'aria-label',
      customisedIntlFormatMessage(intl, localMessages.coachmarkStep, {
        currentStep,
        numberOfSteps: steps.length,
      }),
    );

    $tooltipText.setAttribute('id', `${context}-tooltip-text-${currentStep}`);
    $tooltip.setAttribute('aria-describedby', `${context}-tooltip-text-${currentStep}`);

    window.clearTimeout(this.titleFallbackTimer);
    this.titleFallbackTimer = window.setTimeout(() => this.applyTooltipTitleFallback(currentStep), 400);
  };

  render() {
    const { initialStep, steps } = this.props;
    const { enabled } = this.state;

    return (
      <Steps
        enabled={enabled}
        steps={steps}
        initialStep={initialStep}
        onExit={this.handleExit}
        onComplete={this.handleComplete}
        onAfterChange={this.handleOnChange}
        options={{
          hidePrev: true,
          hideNext: false,
          disableInteraction: true,
          exitOnOverlayClick: false,
          showStepNumbers: false,
          scrollToElement: false,
          showBullets: false,
          exitOnEsc: true,
          showProgress: true,
          tooltipPosition: 'bottom-middle-aligned',
          prevLabel: 'Back',
          nextLabel: 'Next',
        }}
      />
    );
  }
}

const mapStateToProps = ({ coachmarks }) => ({
  ...coachmarks,
});

const mapDispatchToProps = {
  dismissCoachmark,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Coachmarks));
